<template>
    <div class="help_center">
        <div style="display: flex;justify-content: center;">
            <div class="main-area" >
                <div class="multiple">
                    <Table :columns="columns" :data="data" size="small" ref="table">
                        <div slot="operation" slot-scope="{ row }">
                            <a @click="editFeedback" style="padding-right:10px" :data-id="row.id">查看</a>
                            <a  @click="delFeedback" :data-id="row.id">删除</a>
                        </div>
                    </Table>
                </div>
                <div class="pager">
                    <Page :total="count" :page-size="20" :current="page" @on-change="changePage"
                          size="small" show-total show-elevator/>
                </div>
            </div>

            <Modal v-model="addFeedbackModal"
                   title="反馈信息"
                   @on-cancel="() => {addFeedbackModal = false}">
                <Form ref="formValidate" :label-width="120">
                    <FormItem :label="item.date" v-for="(item, index) in formData">
                        <div v-if="item.imgUrl"><a target="_blank" :href="item.imgUrl"><img style="width: 100px" :src="item.imgUrl"></a></div>
                        <div v-else>{{item.speaks}}</div>
                    </FormItem>
                </Form>
            </Modal>
        </div>

    </div>
</template>

<script>
    import TopBar from '../topbar/TopBar.vue';
    import addFile from '../tool/addFile.vue';
    import {mapGetters} from 'vuex';
    import {getFeedbackList, getFeedback, delFeedback} from '@/api/admin'

    export default {
        name: "feedbackManage",
        components: {
            TopBar,addFile
        },
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                uploadType: '',
                uploadModal: false,
                addFeedbackModal: false,
                formData: {

                },
                data: [],
                page: 1,
                count: 0,
                columns: [
                    {
                        "title": "id",
                        "key": "id",
                        "width": 80,
                    },
                    {
                        "title": "反馈人",
                        "key": "username",
                        "width": 150
                    },
                    {
                        "title": "内容概括",
                        "key": "content",
                        "width": 230
                    },
                    {
                        "title": "添加时间",
                        "key": "created_at",
                        "width": 250
                    },
                    {
                        "title": "更新时间",
                        "key": "updated_at",
                        "width": 300,
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "width": 300,
                    }
                ]
            }
        },
        created(){
            this.getList();
        },
        methods: {
            changePage(e) {
                this.page = e;
                this.getList();
            },
            async getList() {
                let that = this;
                let data = {token: that.token, page: this.page}
                let res = await getFeedbackList(that, data);
                if (res.code == 1) {
                    that.data = res.data.list;
                    that.count = res.count;
                }
            },
            addNew() {
                let that = this;
                that.initFormData();
                this.addFeedbackModal = true;
            },
            editFeedback(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                this.throttle(async function () {
                    let data = {token: that.token, id: id}
                    let res = await getFeedback(that, data);
                    if (res.code == 1) {
                        that.formData = res.data.item;
                        that.addFeedbackModal = true;
                    }
                }, 1000);
            },
            delFeedback(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认删除吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id: id}
                            let res = await delFeedback(that, data);
                            if (res.code == 1) {
                                that.$Message.success('删除成功');
                                that.getList();
                            }
                        }, 1000);
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .help_center {
        height: 100%;
        background: #f5f7f9;
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
    }
    .ivu-form-item{
        display: inline-block;
        width: 300px;
        margin-left: 15px;
    }
    .main-area{
        width: 1350px; height: 300px; background-color: #FFFFFF; padding: 20px;
    }

    .multiple {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: 10px;

        .child-div {
            width: 85px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
            font-size: 12px;
        }
        span{
            font-size: 12px;
        }
        label{
            font-size: 12px;
        }
    }

    .delegate {
        justify-content: start;
        align-items: flex-end;
    }
    .dele {
        font-size: 12px;
        padding: 0 25px;
        border: 1px solid #e0e2e6;
        color: #666;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .dele.active {
        padding: 5px 20px;
        background: #0092ff;
        color: #fff;
    }
</style>
